import pro1 from "../assets/project1img.png"
import pro2 from "../assets/project2img.png"


const ProjectCardData = [

    {
        imgsrc: pro1,
        title: "Ecommerce Web application",
        text: "Technologies used - HTML, Tailwind CSS, React Js",
        view: "https://ecommercewebappniyatijain.netlify.app/"

    },
    {
        imgsrc: pro2,
        title: "Niyati-fitnesss website",
        text: "Techonologies used - HTML, CSS, Javascript",
        view: "http://niyatifitnesss.000webhostapp.com/"

    },
]

export default ProjectCardData;